export function orderdisplay(state) {
  return state.orderdisplay;
}
